import { MarkType } from '@const/consts'
import { IDeclaredSigner, IPrepositionMark } from '@store/modules/shared/types'

const hasPredefinedValue = (value?: string | null): boolean =>
  typeof value === 'string' && value.length > 0

export const applyDeclaredSignerDefaults = (
  mark: IPrepositionMark,
  declaredSigner: IDeclaredSigner,
): IPrepositionMark => {
  switch (mark.type) {
    case MarkType.FULLNAME:
      return {
        ...mark,
        value: declaredSigner.fullName ?? '',
      }
    case MarkType.POSITION:
      return {
        ...mark,
        value: declaredSigner.position ?? '',
        isRequired: mark.isRequired || hasPredefinedValue(declaredSigner.position),
      }
    case MarkType.INITIALS:
      return {
        ...mark,
        value: declaredSigner.initials ?? '',
        isRequired: mark.isRequired || hasPredefinedValue(declaredSigner.initials),
      }
    default:
      return { ...mark }
  }
}
